var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessZ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190,
    height: 151,
    viewBox: "0 0 190 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.15,
    height: 136.109,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.556,93.58c27.349-1.63,43.19-13.793,43.19-13.793S161.588,91.95,188.937,93.58c0,12.289,3.587,65.455-43.191,75.235-46.777-9.781-43.19-62.947-43.19-75.235M90.062,84.7c0,15.843-4.624,84.389,55.684,97,60.309-12.61,55.685-81.155,55.685-97-35.26-2.1-55.685-17.783-55.685-17.783S125.322,82.6,90.062,84.7",
    transform: "translate(-89.98 -66.918)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.071,
    y1: 0.903,
    x2: -0.069,
    y2: 0.903,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9c3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#a9c3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d81ee"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.719,204.958l-21.467,16.105-6.841-8.626a5.914,5.914,0,1,0-9.266,7.35l14,17.647,30.678-23.015a5.914,5.914,0,1,0-7.1-9.461",
    transform: "translate(-201.863 -203.774)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -1.255,
    y1: 2.146,
    x2: -1.248,
    y2: 2.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f65e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.044,
    stopColor: "#2f65e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#4d81ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d81ee"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.15,
    height: 129.238,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542.007,295.293l1.287-1.235a1.157,1.157,0,0,0,.034-1.636l-1.2-1.253a1.157,1.157,0,0,1,.034-1.636l.117-.112a1.157,1.157,0,0,1,1.635.034l1.2,1.253a1.157,1.157,0,0,0,1.636.034l1.286-1.235a1.157,1.157,0,0,1,1.6,1.669l-1.286,1.235a1.157,1.157,0,0,0-.034,1.636l1.2,1.253a1.157,1.157,0,0,1-.034,1.636l-.117.112a1.157,1.157,0,0,1-1.636-.034l-1.2-1.253a1.157,1.157,0,0,0-1.636-.034l-1.286,1.234a1.157,1.157,0,0,1-1.636-.034h0a1.157,1.157,0,0,1,.034-1.636",
    transform: "translate(-541.651 -289.1)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -19.769,
    y1: 5.357,
    x2: -19.733,
    y2: 5.357,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.693,39.109h-.014a.64.64,0,0,1-.45-.2l-.435-.453a.2.2,0,0,0-.136-.06.152.152,0,0,0-.138.054l-.466.446a.642.642,0,0,1-.89-.927l.465-.447a.194.194,0,0,0,.006-.275L172.2,36.8a.643.643,0,0,1,.019-.909l.042-.04a.644.644,0,0,1,.909.018l.435.453a.2.2,0,0,0,.275.006l.465-.446a.619.619,0,0,1,.458-.179.642.642,0,0,1,.432,1.106l-.465.446a.194.194,0,0,0-.006.274l.435.453a.642.642,0,0,1-.018.908l-.043.041a.637.637,0,0,1-.444.178m-1.039-1.158h.013a.637.637,0,0,1,.451.2l.435.453a.193.193,0,0,0,.136.06.211.211,0,0,0,.139-.054l.043-.041a.193.193,0,0,0,0-.274l-.435-.453a.642.642,0,0,1,.019-.908l.465-.446a.195.195,0,0,0-.131-.335.188.188,0,0,0-.139.054l-.465.446a.643.643,0,0,1-.908-.019l-.435-.453a.2.2,0,0,0-.275-.006l-.041.04a.2.2,0,0,0-.006.275l.434.453a.643.643,0,0,1-.018.908l-.466.447a.195.195,0,0,0-.006.275.194.194,0,0,0,.136.06.218.218,0,0,0,.138-.054l.466-.446a.637.637,0,0,1,.444-.179",
    transform: "translate(-171.967 -35.671)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -15.491,
    y1: 35.306,
    x2: -15.4,
    y2: 35.306,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4,139.9l-1.766-.036a1.146,1.146,0,0,0-1.169,1.122l-.035,1.719a1.146,1.146,0,0,1-1.169,1.122l-.16,0a1.146,1.146,0,0,1-1.122-1.169l.035-1.72a1.146,1.146,0,0,0-1.122-1.169l-1.765-.036a1.146,1.146,0,0,1,.047-2.291l1.766.036A1.146,1.146,0,0,0,4.1,136.353l.035-1.72a1.146,1.146,0,0,1,1.169-1.122l.161,0a1.146,1.146,0,0,1,1.122,1.169L6.556,136.4a1.146,1.146,0,0,0,1.122,1.169l1.765.036a1.145,1.145,0,0,1,1.122,1.169h0A1.146,1.146,0,0,1,9.4,139.9",
    transform: "translate(0 -133.511)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.001,
    y1: 9.115,
    x2: 0.031,
    y2: 9.115,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.535,6.174a3.088,3.088,0,0,1-2.963-3.946,3.086,3.086,0,1,1,2.963,3.946m0-5.726a2.642,2.642,0,1,0,.739.106,2.625,2.625,0,0,0-.739-.106m2.753,3.437h0Z",
    transform: "translate(-473.45 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -21.535,
    y1: 21.691,
    x2: -21.49,
    y2: 21.691,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.779,371.408a3.087,3.087,0,1,1,2.959-2.228,3.091,3.091,0,0,1-2.959,2.228m0-5.726a2.638,2.638,0,1,0,.734.1,2.643,2.643,0,0,0-.734-.1",
    transform: "translate(-52.687 -365.234)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -2.351,
    y1: 3.366,
    x2: -2.305,
    y2: 3.366,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.763,197.273a.222.222,0,0,1-.151-.059q-.228-.209-.454-.42a.224.224,0,1,1,.306-.328q.224.21.45.418a.224.224,0,0,1-.151.389m-1.424-1.346a.224.224,0,0,1-.156-.063q-.484-.471-.958-.949a.224.224,0,0,1,.319-.315q.47.475.952.943a.224.224,0,0,1-.156.385m-1.892-1.91a.224.224,0,0,1-.162-.07q-.465-.489-.92-.985a.224.224,0,1,1,.33-.3q.451.493.914.979a.224.224,0,0,1-.162.378m-1.816-1.982a.222.222,0,0,1-.168-.076q-.447-.506-.882-1.019a.224.224,0,1,1,.341-.29q.433.509.877,1.013a.224.224,0,0,1-.168.372m-1.741-2.048a.223.223,0,0,1-.173-.082q-.427-.523-.844-1.051a.224.224,0,1,1,.352-.277q.414.525.839,1.045a.224.224,0,0,1-.173.366m-1.663-2.111a.225.225,0,0,1-.179-.089q-.408-.538-.806-1.081a.224.224,0,1,1,.361-.265q.4.54.8,1.075a.224.224,0,0,1-.178.36m-1.588-2.17a.224.224,0,0,1-.183-.1q-.388-.552-.767-1.109a.224.224,0,0,1,.371-.252q.376.554.762,1.1a.224.224,0,0,1-.183.353m-1.509-2.224a.224.224,0,0,1-.187-.1q-.37-.565-.728-1.135a.224.224,0,1,1,.379-.239q.357.566.724,1.128a.224.224,0,0,1-.187.347M74.7,181.208a.223.223,0,0,1-.192-.108q-.349-.577-.689-1.158a.224.224,0,0,1,.387-.226q.338.578.686,1.152a.224.224,0,0,1-.192.34m-1.357-2.321a.224.224,0,0,1-.2-.114q-.331-.588-.651-1.18a.224.224,0,0,1,.394-.214q.319.589.648,1.173a.224.224,0,0,1-.085.305.219.219,0,0,1-.11.029m-1.279-2.359a.224.224,0,0,1-.2-.12q-.31-.6-.612-1.2a.224.224,0,1,1,.4-.2q.3.6.609,1.189a.224.224,0,0,1-.095.3.226.226,0,0,1-.1.025m-1.2-2.393a.224.224,0,0,1-.2-.126q-.293-.606-.576-1.214a.224.224,0,1,1,.406-.189q.282.605.573,1.207a.224.224,0,0,1-.2.322m-1.131-2.429a.224.224,0,0,1-.2-.133q-.274-.613-.54-1.229a.224.224,0,1,1,.411-.178q.265.613.538,1.224a.224.224,0,0,1-.113.3.221.221,0,0,1-.092.019m-1.061-2.46a.224.224,0,0,1-.207-.139q-.257-.621-.506-1.243a.224.224,0,0,1,.416-.166q.248.62.5,1.238a.224.224,0,0,1-.207.31m-.992-2.488a.224.224,0,0,1-.209-.144q-.242-.63-.474-1.262a.224.224,0,1,1,.42-.155q.233.629.472,1.256a.224.224,0,0,1-.209.3m-.93-2.523a.224.224,0,0,1-.211-.15q-.225-.636-.441-1.273a.224.224,0,0,1,.424-.144q.215.634.439,1.268a.224.224,0,0,1-.137.286.228.228,0,0,1-.074.013m-.864-2.546a.224.224,0,0,1-.213-.155q-.209-.641-.41-1.284a.224.224,0,0,1,.428-.134q.2.64.408,1.279a.224.224,0,0,1-.213.293m-.8-2.567a.225.225,0,0,1-.215-.16q-.192-.646-.378-1.293a.224.224,0,1,1,.43-.124q.185.644.377,1.288a.225.225,0,0,1-.215.288m-.74-2.585a.224.224,0,0,1-.216-.165q-.179-.651-.349-1.3a.224.224,0,1,1,.433-.113q.17.648.348,1.3a.224.224,0,0,1-.157.275.218.218,0,0,1-.06.008m-.683-2.6a.225.225,0,0,1-.218-.17q-.163-.655-.32-1.308a.224.224,0,1,1,.436-.1q.156.652.319,1.3a.225.225,0,0,1-.163.272.233.233,0,0,1-.054.007m-.625-2.616a.224.224,0,0,1-.218-.174q-.15-.658-.293-1.315a.224.224,0,1,1,.438-.095q.142.654.292,1.31a.224.224,0,0,1-.169.268.212.212,0,0,1-.05.006m-.572-2.628a.224.224,0,0,1-.219-.179q-.137-.661-.266-1.32a.224.224,0,1,1,.439-.086q.129.656.265,1.316a.224.224,0,0,1-.174.265.253.253,0,0,1-.046,0m-.519-2.639a.224.224,0,0,1-.219-.183q-.124-.664-.241-1.325a.224.224,0,0,1,.441-.078q.117.659.24,1.321a.224.224,0,0,1-.179.261.238.238,0,0,1-.042,0M61.47,143.4a.224.224,0,0,1-.22-.187q-.111-.667-.216-1.33a.225.225,0,0,1,.187-.256.228.228,0,0,1,.256.187q.1.661.215,1.325a.224.224,0,0,1-.184.258.214.214,0,0,1-.037,0m-.419-2.657a.224.224,0,0,1-.221-.191q-.1-.668-.192-1.333a.224.224,0,0,1,.191-.253.226.226,0,0,1,.253.191q.093.663.192,1.329a.224.224,0,0,1-.188.255l-.034,0m-.373-2.663a.224.224,0,0,1-.222-.2q-.087-.67-.169-1.336a.224.224,0,1,1,.445-.054q.081.664.169,1.332a.224.224,0,0,1-.193.251l-.029,0m-.327-2.669a.224.224,0,0,1-.222-.2q-.077-.672-.147-1.338a.224.224,0,0,1,.445-.048q.071.665.147,1.335a.224.224,0,0,1-.2.248l-.026,0m-.285-2.675a.224.224,0,0,1-.223-.2q-.066-.674-.126-1.341a.224.224,0,0,1,.2-.243.231.231,0,0,1,.243.2q.06.665.126,1.337a.225.225,0,0,1-.2.245h-.023m-.241-2.679a.224.224,0,0,1-.223-.206q-.055-.675-.107-1.342a.224.224,0,0,1,.447-.034q.05.665.106,1.339a.224.224,0,0,1-.2.242h-.019m-.2-2.682a.225.225,0,0,1-.223-.209q-.046-.676-.087-1.344a.224.224,0,0,1,.21-.237.229.229,0,0,1,.237.21q.041.665.087,1.341a.224.224,0,0,1-.208.239h-.016m-.164-2.685a.224.224,0,0,1-.224-.212q-.037-.678-.068-1.345a.224.224,0,0,1,.213-.234.228.228,0,0,1,.234.214q.032.665.068,1.341a.224.224,0,0,1-.211.236h-.012m-.128-2.687a.224.224,0,0,1-.224-.215q-.027-.68-.05-1.346a.224.224,0,0,1,.216-.231.219.219,0,0,1,.232.216q.023.665.05,1.343a.224.224,0,0,1-.215.233H59.33m-.093-2.689a.224.224,0,0,1-.224-.218q-.019-.68-.034-1.346a.225.225,0,0,1,.219-.229.218.218,0,0,1,.229.219q.015.664.034,1.343a.224.224,0,0,1-.218.23Zm-.061-2.69a.224.224,0,0,1-.224-.22q-.011-.683-.018-1.347a.224.224,0,0,1,.448,0q.007.663.018,1.344a.224.224,0,0,1-.22.228Zm-.03-2.691a.224.224,0,0,1-.224-.223q0-.685-.005-1.346a.224.224,0,0,1,.224-.224h0a.224.224,0,0,1,.224.224q0,.66,0,1.345a.223.223,0,0,1-.223.225Zm0-2.69h0a.224.224,0,0,1-.224-.225q0-.687.007-1.345a.224.224,0,0,1,.224-.223h0a.224.224,0,0,1,.222.226q0,.657-.007,1.343a.224.224,0,0,1-.224.224m.019-2.689h0a.224.224,0,0,1-.222-.226q.007-.692.015-1.345a.224.224,0,0,1,.224-.221h0a.224.224,0,0,1,.221.227q-.008.653-.015,1.344a.224.224,0,0,1-.224.222m.034-2.689h0a.224.224,0,0,1-.221-.227l.018-1.345a.224.224,0,0,1,.224-.221h0a.224.224,0,0,1,.221.227l-.018,1.344a.224.224,0,0,1-.224.221m.034-2.689h0a.224.224,0,0,1-.222-.226q.007-.717.007-1.342a.224.224,0,0,1,.448,0q0,.627-.008,1.346a.224.224,0,0,1-.224.222",
    transform: "translate(-58.917 -101.387)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -0.635,
    y1: 1.088,
    x2: -0.624,
    y2: 1.088,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.041,403.16a13.54,13.54,0,0,0-4.272-.983l2-1.066.855-2.1a13.535,13.535,0,0,0,1.417,4.148",
    transform: "translate(-143.769 -399.012)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -10.551,
    y1: 2.656,
    x2: -10.478,
    y2: 2.656,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.652,202.723l-.309-.324c28.43-27.128,27.785-73.256,27.542-90.621l-.014-1.056.448-.006.014,1.056c.122,8.7.348,24.9-3.028,41.975-4.116,20.817-12.41,37.295-24.653,48.977",
    transform: "translate(-387.343 -110.715)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -4.271,
    y1: 1.102,
    x2: -4.26,
    y2: 1.102,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.219,102.1a13.539,13.539,0,0,0,2.174,3.807l-2.14-.747-2.122.795a13.538,13.538,0,0,0,2.088-3.854",
    transform: "translate(-469.131 -102.101)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: -34.51,
    y1: 27.01,
    x2: -34.437,
    y2: 27.01,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.136,396.758l-.346-.007a.224.224,0,0,0-.229.22l-.007.337a.225.225,0,0,1-.229.22h-.031a.225.225,0,0,1-.22-.229l.007-.337a.225.225,0,0,0-.22-.229l-.346-.007a.225.225,0,1,1,.009-.449l.346.007a.224.224,0,0,0,.229-.22l.007-.337a.225.225,0,0,1,.229-.22h.032a.225.225,0,0,1,.22.229l-.007.337a.225.225,0,0,0,.22.229l.346.007a.224.224,0,0,1,.22.229h0a.225.225,0,0,1-.229.22",
    transform: "translate(-459.294 -395.506)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: -69.347,
    y1: 5.978,
    x2: -69.196,
    y2: 5.978,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.12,432.16a.314.314,0,0,0,0,.627h11.716a.314.314,0,0,0,0-.627Z",
    transform: "translate(-151.807 -432.16)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: -3.856,
    y1: 1,
    x2: -3.83,
    y2: 1,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.72,432.16a.314.314,0,0,0,0,.627h2.289a.314.314,0,0,0,0-.627Z",
    transform: "translate(-299.407 -432.16)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: -32.201,
    y1: 1,
    x2: -32.094,
    y2: 1,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.177,432.16a.314.314,0,0,0,0,.627h28.591a.314.314,0,0,0,0-.627Z",
    transform: "translate(-200.864 -432.16)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: -2.155,
    y1: 1,
    x2: -2.144,
    y2: 1,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.3,432.16a.314.314,0,1,0,0,.627h21.612a.314.314,0,0,0,0-.627Z",
    transform: "translate(-312.983 -432.16)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: -4.412,
    y1: 1,
    x2: -4.398,
    y2: 1,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 151
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "al",
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 151,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.944 7.446)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.336,121.785c-27.349-1.63-43.19-13.793-43.19-13.793s-15.842,12.163-43.191,13.793c0,12.289-3.587,65.455,43.191,75.235,46.777-9.781,43.19-62.947,43.19-75.235",
    transform: "translate(-89.171 -74.137)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.209 20.979)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147.16,
    height: 143.12,
    transform: "matrix(0.963, -0.27, 0.27, 0.963, -34.422, 8.392)",
    fill: "url(#d)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.432,84.7c-35.26-2.1-55.684-17.783-55.684-17.783S125.323,82.6,90.063,84.7c0,15.843-4.624,84.389,55.684,97C206.056,169.09,201.432,100.544,201.432,84.7Zm-55.684,84.114c-46.778-9.781-43.191-62.947-43.191-75.235,27.349-1.63,43.191-13.793,43.191-13.793s15.841,12.163,43.19,13.793C188.938,105.868,192.525,159.035,145.747,168.815Z",
    transform: "translate(-61.772 -45.939)",
    fill: "none",
    stroke: "#4d81ee",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.284 63.883)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.845,
    height: 33.66,
    transform: "translate(-0.749 0)",
    fill: "url(#g)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.807 90.633)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.583,
    height: 8.511,
    transform: "translate(-0.12 -0.12)",
    fill: "url(#k)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.912 11.183)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.48,
    height: 3.54,
    transform: "translate(-0.012 -0.066)",
    fill: "url(#m)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 41.856)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.591,
    height: 10.342,
    transform: "translate(-0.013 -0.013)",
    fill: "url(#o)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.426 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.876,
    height: 6.28,
    transform: "translate(-0.352 -0.106)",
    fill: "url(#q)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.517 114.501)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.876,
    height: 6.526,
    transform: "translate(-0.352 -0.352)",
    fill: "url(#s)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.47 31.785)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.095,
    height: 95.887,
    transform: "translate(0 0)",
    fill: "url(#u)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.071 125.09)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.272,
    height: 4.148,
    transform: "translate(0)",
    fill: "url(#w)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.432 34.709)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.43,
    height: 92.008,
    transform: "translate(0 0)",
    fill: "url(#y)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147.072 32.009)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.262,
    height: 3.854,
    transform: "translate(0 0)",
    fill: "url(#aa)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.988 123.991)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.076,
    height: 2.027,
    transform: "translate(-0.002 -0.002)",
    fill: "url(#ac)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.591 135.482)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.343,
    height: 0.627,
    fill: "url(#ae)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.864 135.482)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.915,
    height: 0.627,
    transform: "translate(0)",
    fill: "url(#ag)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.971 135.482)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.218,
    height: 0.627,
    transform: "translate(0)",
    fill: "url(#ai)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.12 135.482)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.239,
    height: 0.627,
    fill: "url(#ak)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessZ);
export default __webpack_public_path__ + "static/media/successZ.46314cf518dcdc6d4ea3cb1c733c3d9b.svg";
export { ForwardRef as ReactComponent };